import { render } from "./BalAsset.vue?vue&type=template&id=5ec3904a"
import script from "./BalAsset.vue?vue&type=script&lang=js"
export * from "./BalAsset.vue?vue&type=script&lang=js"
script.render = render

export default script